<svg width="0" height="0" style="position:absolute">
  <defs>
    <pattern id="hatchGreen" patternUnits="userSpaceOnUse" width="8" height="8" patternTransform="rotate(45)">
      <rect width="8" height="8" fill="#22c55e"></rect>
      <line x1="0" y1="0" x2="0" y2="8" stroke="#fff" stroke-width="3"></line>
    </pattern>
    <pattern id="hatchRed" patternUnits="userSpaceOnUse" width="8" height="8" patternTransform="rotate(45)">
      <rect width="8" height="8" fill="#f87171"></rect>
      <line x1="0" y1="0" x2="0" y2="8" stroke="#fff" stroke-width="3"></line>
    </pattern>
  </defs>
</svg>
